
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M15.042 15.042H3.958V6.333h11.084v8.709zm0-12.667h-.792V.792h-1.583v1.583H6.333V.792H4.75v1.583h-.792c-.878 0-1.583.713-1.583 1.583v11.084a1.583 1.583 0 001.583 1.583h11.084a1.583 1.583 0 001.583-1.583V3.958a1.583 1.583 0 00-1.583-1.583zm-1.956 6.38l-.839-.838-3.863 3.863-1.679-1.678-.839.839 2.518 2.517 4.702-4.702z","fill-opacity":".7"}}),_c('circle',{attrs:{"cx":"2.5","cy":"14.5","r":"4.5","fill":"#fff"}}),_c('path',{attrs:{"d":"M5.916 14.517h.1v-1.034h-2.5v-2.5H2.483v2.5h-2.5v1.034h2.5v2.5h1.033v-2.5h2.4z","fill":"#188038","stroke":"#188038","stroke-width":".2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h19v19H0z"}})])])])
          )
        }
      }
    